import { render, staticRenderFns } from "./ViewContractDetails.vue?vue&type=template&id=74775be2&"
import script from "./ViewContractDetails.vue?vue&type=script&lang=js&"
export * from "./ViewContractDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports